import React, { useEffect } from 'react'
import $ from 'jquery';
import 'datatables.net-dt/js/dataTables.dataTables.js';
import 'datatables.net-responsive-dt/js/responsive.dataTables.js';
import 'datatables.net-responsive-dt/css/responsive.dataTables.css';
import { Icon } from '@iconify/react/dist/iconify.js';
import { Link, useNavigate } from 'react-router-dom';
import { API_URL } from '..';

const StaffTable = ({data}) => {
    const history = useNavigate();
    const handleDelete = async(id) =>{
        const apiCall = await fetch(`${API_URL}/api/user/delete/${id}`, {method:'DELETE'});
        if(apiCall.status ==200){
            window.location.reload()

        }
    }
    useEffect(() => {
        const user = JSON.parse(localStorage.getItem('user'))
      
        const table = $('#dataTable').DataTable({
        data: data,
        responsive:true,
        pageLength: 10,
        order: [[0, 'desc']],
         columns: [
            { data: "id" ,render :(data, type, row)=>{
                return `<span style="cursor:pointer;text-decoration:underline" class="dropdown-item view-btn" data-id="${row.id}">${data}</span>`;;
              } },
            { data: 'name' },
            { data: 'phone' },
            { data: 'role' },
           
            {
              data: null, // Indicates this column is generated using the `render` function
              render: function (data, type, row) {
                // Return HTML string for buttons
                return `
                <div class="dropdown">
                <button class="dropdown-toggle" type="button" data-bs-toggle="dropdown" aria-expanded="false">
                  <i class="ph ph-list"></i>
                </button>
                <ul class="dropdown-menu">
                  <li><a style="cursor:pointer" class="dropdown-item view-btn" data-id="${row.id}"><i class="ph ph-eye"></i> View </a></li>
                 
                  <li><a style="cursor:pointer" class="dropdown-item delete-btn" data-id="${row.id}"><i class="ph ph-trash"></i> Delete </a></li>
                </ul>
              </div>
                
                `;
              },
              title: 'Actions', // The header for the column
              orderable: false // Optional: Prevent sorting on this column
            }
        ]
        });
        $('#dataTable tbody').on('click', '.view-btn', function () {
          const id = $(this).data('id');
          history(`/staff/${id}`); // Navigate to the edit page
        });
       
        // Event listener for delete button
        $('#dataTable tbody').on('click', '.delete-btn', function () {
          const id = $(this).data('id');
          handleDelete(id); // Call the delete function
        });
        return () => {
            table.destroy(true);
        };
    }, []);
    return (
        <div className="card basic-data-table">
            <div className="card-header ">
                <div className='row'>

                <h5 className="card-title mb-0 col-md-6">List of Staff</h5>
                <div className='col-md-6 text-end'>

                <Link to={'/add-staff'} className="btn btn-primary" style={{background:'#db6f2f',borderColor:'#db6f2f'}} >Add New</Link>
                </div>
                </div>
            </div>
            <div className="card-body">
                <table
                    className="table bordered-table mb-0"
                    id="dataTable"
                    data-page-length={10}
                >
                    <thead>
                        <tr>
                            <th scope="col">
                                <div className="form-check style-check d-flex align-items-center">
                                    
                                    <label className="form-check-label">S.L</label>
                                </div>
                            </th>
                            
                            <th scope="col">Name</th>
                            <th scope="col">Phone</th>
                            <th scope="col">Role</th>
                            <th scope="col">Action</th>
                        </tr>
                    </thead>
                   <tbody>
                    
                   </tbody>
                </table>
            </div>
        </div>

    )
}

export default StaffTable